import { useState } from 'react';

import { EventForUser } from 'legacy/events/types';

/**
 * Manages the state of accepted waivers for an event.
 */
const useWaivers = (event: EventForUser) => {
  const [totalCheckedWaivers, setTotalCheckedWaivers] = useState(0);
  const data = event?.waivers || [];

  const allWaiversAccepted = totalCheckedWaivers === data.length;

  const reset = () => {
    setTotalCheckedWaivers(0);
  };

  return {
    data,
    totalCheckedWaivers,
    setTotalCheckedWaivers,
    allWaiversAccepted,
    reset
  };
};

export default useWaivers;
